import React from 'react';
import { Modal, Checkbox, Button, message, DatePicker } from 'antd';
import API_URL from '../../../common/url';
import $ from '../../../common/AjaxRequest';
import dictCache from '../../../common/dictCache';
import ExportUtil from '../../../common/ExportUtil';
import SelectProvince from '../../common/SelectProvince';
import moment from 'moment';

const CheckboxGroup = Checkbox.Group;
const monthFormat = 'YYYY-MM';
const { MonthPicker } = DatePicker;

class ExportModal extends React.Component {
    state = {
        visible: false,
        loading: false,
        basicOptions: [
            { label: 'CRC人数', value: '_crcNum' },
            { label: '主管以上人数', value: '_aboveSupervisorNum' },
            { label: 'CRC新增', value: '_crcAddNum' },
            { label: '新人人数', value: '_newEmployeeNum' },
            { label: '当月新site上岗确认FTE', value: '_newOnDutyConfirmFte' },
            { label: '项目确认FTE', value: '_investigationConfirmFte' },
            { label: '新人确认FTE', value: '_newEmployeeConfirmFte' },
            { label: '医院覆盖量', value: '_invHospitalNum' },
            { label: '科室覆盖量', value: '_invDeptNum' },
            { label: '承担项目数量', value: '_undertakeInvNum' },
            { label: '临床I期项目数', value: '_clinicalOneInvNum' },
            { label: '临床II期项目数', value: '_clinicalTwoInvNum' },
            { label: '临床III期项目数', value: '_clinicalThreeInvNum' },
            { label: '临床IV期项目数', value: '_clinicalFourInvNum' },
            { label: '其他项目数', value: '_otherInvNum' },
            { label: '肿瘤项目数量', value: '_tumourInvNum' },
            { label: '非肿瘤项目数量', value: '_notTumourInvNum' },
            { label: '综合项目数量', value: '_comprehensiveInvNum' },
            { label: '处于入组期项目数量', value: '_intoGroupItemInvestigationNum' },
            { label: '当月入组病例数', value: '_currentMonthPatientNum' },
            { label: '当月新增访视数', value: '_currentMonthAddVisitNum' },
            { label: '当月新增确认标准访视数', value: '_currentMonthStandardAddVisitNum' },
            { label: '新启动中心数量', value: '_newStartSiteNum' },
            { label: '在组患者数量', value: '_inGroupPatientNum' },
            { label: '重大事件发生数量', value: '_majorEventsNum' },
        ],
        values: [],
        searchDate: {
            beginDate: moment().format(monthFormat),
            endDate: moment().format(monthFormat),
        },
        areaParams: {},
        hasCheckedArea: [],
        areaName: [],
        maxDate: '',
        checkAll:false,
    }

    componentDidMount() {
        this.queryEffectiveDate();
    }
    
    queryEffectiveDate = () => {
        dictCache.getDict('EFFECTIVE_DATE', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.home.queryEffectiveDate,
                data: {},
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            const { date } = res;
            const maxDate = date ? date.slice(0, 7) : '';
            this.setState({ maxDate }, () => {
                this.search();
            });
        });
    }

    show = () => {
        const { searchParams: { date, areaName, hasCheckedArea,areaParams } } = this.props;
        
        console.log(areaParams);
        this.setState({
            values: [],
            visible: true,
            searchDate: {
                beginDate: date,
                endDate:date,
            },
            areaName, 
            hasCheckedArea,
            areaParams
        });
    }

    hide = () => {
        this.setState({ 
            visible: false, 
            searchDate: {
                beginDate: moment().format(monthFormat),
                endDate: moment().format(monthFormat),
            },
            areaName: [], 
            areaParams: {},
            values: [],
            hasCheckedArea: [],
            checkAll:false,
        });
    }

    handleCheckChange = (values) => {
        const { basicOptions= [] } = this.state;
        this.setState({ values, checkAll: values.length == basicOptions.length});
    }

    handleSubmit = () => {
        //const { searchParams } = this.props;
        const { values, areaParams, searchDate } = this.state;
        const params = { ...areaParams, ...searchDate }; // ...searchParams,
        values.forEach(i => params[i] = 1);
        this.addToDownloadSite(params, null, API_URL.user.exportAnalysisRegionCity);
        // if (values.length) {
        // }
        this.hide();
    }

    addToDownloadSite = (params, pagination, url) => {
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.common.startAsynchronousExport,
            data: { type: 'ANALYSIS_REGION_CITY' },
            dataType: 'json',
            doneResult: (res) => {
                const { success, asynchronousExportId } = res;
                message.success(success);
                ExportUtil.export({ ...params, asynchronousExportId }, pagination, url);
                this.setState({ loading: false });
            },
            errorResult: (() => {
                this.setState({ loading: false });
            })
        };
        $.sendRequest(options);
    }

    handleDateChange = (data, dateString,key) => {
        const { searchDate } = this.state;
        searchDate[key] = dateString;
        this.setState({ searchDate });
    }

    saveProvince = (checkedArea) => {
        const areaParams = {};
        checkedArea.map(item => {
            areaParams[`params[${item.props.title}]`] = item.key;
        });
        const areaList = checkedArea.map(item => item.props.title);
        const hasCheckedArea = checkedArea.map(item => item.key);

        let areaChooseAry=[];//选择城市或省份时的区域
        checkedArea.map((item, index) => {
          const{area}=item.props;
          const{key}=item;
          const ifChooseProvinceOrCity = ((key.indexOf('CITY') > -1)||(key.indexOf("AREAPROVINCE")>-1));
         
          if(area&&ifChooseProvinceOrCity){
            const begin = area.indexOf('_') + 1;
            const last = area.length;
            const areaId = area.substring(begin, last);
            areaChooseAry.push(Number(areaId));           
          }        
        });
        console.log(areaChooseAry.reduce((prev,cur) => prev.includes(cur) ? prev : [...prev,cur],[]) );
        this.setState({
            areaParams,
            hasCheckedArea,
            areaName: areaList.join(','),
        });
        //this.props.setChooseArea(areaChooseAry);
    }

    onCheckAll = (e)=>{
        const checkAll = e.target.checked;
        const { basicOptions= [] } = this.state;
        let arr = [];
        if(checkAll){
            (basicOptions || []).forEach(item=>{arr.push(item.value);})
        } else {
            arr = [];
        }
        this.setState({
            checkAll,
            values:arr,
        })
    }

    render() {
        const { values, visible, loading, 
            basicOptions,
            searchDate: {
                beginDate,
                endDate,
            },
            maxDate,
            areaName,
            hasCheckedArea,
            checkAll
        } = this.state;
        console.log(areaName,hasCheckedArea);
        return (
            <Modal
                title="导出"
                visible={visible}
                onCancel={this.hide}
                className="condition-modal"
                wrapClassName="vertical-center-modal"
                maskClosable={false}
                width="800px"
                footer={<Button type="primary" onClick={this.handleSubmit} loading={loading}>确定</Button>}
            >
                <div className="con-options config_column">
                    <div>请选择导出范围</div>
                    <div className="form-item" style={{ lineHeight: '40px' }}>
                        <label className="ui-label">时间：</label>
                        <MonthPicker
                            style={{width: 90}}
                            format={monthFormat}
                            value={beginDate ? moment(beginDate) : null}
                            placeholder="请选择"
                            allowClear={false}
                            onChange={(value,dataString)=>this.handleDateChange(value,dataString,'beginDate')}
                            className="w-90-select"
                            disabledDate={current => current.valueOf() > moment(maxDate).valueOf() }
                        />&nbsp;至&nbsp;
                        <MonthPicker
                            style={{width: 90}}
                            format={monthFormat}
                            value={endDate ? moment(endDate) : null}
                            placeholder="请选择"
                            allowClear={false}
                            onChange={(value,dataString)=>this.handleDateChange(value,dataString,'endDate')}
                            className="w-90-select"
                            disabledDate={current => current.valueOf() > moment(maxDate).valueOf() }
                        />
                    </div>
                    <div className="form-item" style={{ lineHeight: '40px' }}>
                        <label className="ui-label">区域/城市：</label>
                        {
                            visible && <SelectProvince areaName={areaName} saveProvince={this.saveProvince} hasCheckedArea={hasCheckedArea} />
                        }
                    </div>
                    <div>请选择导出细项(可不勾选)</div>
                    <div style={{ marginLeft: 18, lineHeight: '30px' }}>
                        <div style={{ display:'inline-flex' }}>
                            <Checkbox checked = {checkAll} onChange={this.onCheckAll}>全选</Checkbox>
                        </div>
                        <CheckboxGroup
                            value={values}
                            options={basicOptions}
                            onChange={this.handleCheckChange}
                        />
                    </div>
                </div>
            </Modal>
        );
    }
}

export default ExportModal;



// WEBPACK FOOTER //
// ./src/components/user/areaCityAnalysis/ExportModal.js